export enum CandidateApplySource {
    app = 'app',
    jobLandingPage = 'jobLandingPage',
}
